import { getUrlWithId, useGetFetch } from '../../utils/reactQuery';
import { pathToUrl } from '../../utils/router';
import { ApiRoutesEnum } from '../../utils/routes';
import { EmailType } from '../emails/Emails.type';

export const useGetEmail = (id: string) =>
  useGetFetch<EmailType>({ url: pathToUrl(getUrlWithId(ApiRoutesEnum.getEmail, id)), config: { enabled: !!id } });
